import { css } from "styled-components";

const sizes = {
	phone: 767,
	smallPhone: 374,
	large: 768,
	desktop: 991,
	wide: 1199
};

export const media = Object.keys(sizes).reduce((accumulator, label) => {
	const emSize = sizes[label] / 16;
	accumulator[label] = (...args) => css`
		@media (max-width: ${emSize}em) {
			${css(...args)};
		}
	`;
	return accumulator;
}, {});

export function hexToRgba(hex, opacity = 1) {
	hex = hex.replace("#", "");
	hex = hex.length === 3 ? `${hex}${hex}` : hex;
	let red = parseInt(hex.substring(0, 2), 16);
	let green = parseInt(hex.substring(2, 4), 16);
	let blue = parseInt(hex.substring(4, 6), 16);
	return `rgba(${red}, ${green}, ${blue}, ${opacity})`;
}
export function LightenDarkenColor(col, amt) {
	var usePound = false;

	if (col[0] === "#") {
		col = col.slice(1);
		usePound = true;
	}

	var num = parseInt(col, 16);

	var r = (num >> 16) + amt;

	if (r > 255) r = 255;
	else if (r < 0) r = 0;

	var b = ((num >> 8) & 0x00ff) + amt;

	if (b > 255) b = 255;
	else if (b < 0) b = 0;

	var g = (num & 0x0000ff) + amt;

	if (g > 255) g = 255;
	else if (g < 0) g = 0;

	return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
}
export function em(size) {
	const emSize = parseFloat(size.replace("px", "")) / 16;

	return `${emSize}em`;
}

export function rem(size) {
	const remSize = parseFloat(size.replace("px", "")) / 16;

	return `${remSize}rem`;
}
